import { useLegalMeta } from "../providers/BootstrapProvider";

/**
 * LegalFooter — Phase 71.
 *
 * One shared footer rendering every legal page link. Titles come live
 * from the CMS (useLegalMeta), so if the founder renames a legal page,
 * the footer label updates automatically everywhere it is mounted.
 */

const LEGAL_LINKS = [
  { slug: "privacy", href: "/privacy", fallback: "Privacy Policy" },
  { slug: "terms", href: "/terms", fallback: "Terms of Service" },
  { slug: "cookie", href: "/cookie-policy", fallback: "Cookie Policy" },
  { slug: "disclaimer", href: "/disclaimer", fallback: "Disclaimer" },
];

const LegalFooter = ({ compact = false }) => {
  const { titles } = useLegalMeta();

  return (
    <footer
      className="border-t border-[#E5DFEC] bg-white mt-16"
      data-testid="legal-footer"
    >
      <div className="max-w-5xl mx-auto px-6 py-6 text-xs text-[#94A3B8] flex flex-wrap items-center justify-between gap-3">
        <span>© {new Date().getFullYear()} Dental Hygiene Development Hub</span>
        <div className="flex gap-5 flex-wrap">
          {LEGAL_LINKS.map((l) => (
            <a
              key={l.slug}
              href={l.href}
              className="hover:text-[#6B4E8A]"
              data-testid={`footer-link-${l.slug}`}
            >
              {(titles && titles[l.slug]) || l.fallback}
            </a>
          ))}
          {!compact && (
            <a
              href="mailto:support@dhdh.ca"
              className="hover:text-[#6B4E8A]"
              data-testid="footer-link-contact"
            >
              Contact
            </a>
          )}
        </div>
      </div>
    </footer>
  );
};

export default LegalFooter;
